import * as React from "react";

function ExclamationCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("g", {
    id: "ExclamationCircleOutline-ExclamationCircleOutline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ExclamationCircleOutline-\u7F16\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ExclamationCircleOutline-\u77E9\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,2 C36.1502645,2 46,11.8497355 46,24 C46,36.1502645 36.1502645,46 24,46 C11.8497355,46 2,36.1502645 2,24 C2,11.8497355 11.8497355,2 24,2 Z M24,5 C13.5065898,5 5,13.5065898 5,24 C5,34.4934102 13.5065898,43 24,43 C34.4934102,43 43,34.4934102 43,24 C43,13.5065898 34.4934102,5 24,5 Z M25.1,31 C25.3209139,31 25.5,31.1790861 25.5,31.4 L25.5,33.6 C25.5,33.8209139 25.3209139,34 25.1,34 L22.9,34 C22.6790861,34 22.5,33.8209139 22.5,33.6 L22.5,31.4 C22.5,31.1790861 22.6790861,31 22.9,31 L25.1,31 Z M25.1,14 C25.3209139,14 25.5,14.1790861 25.5,14.4 L25.5,27.6 C25.5,27.8209139 25.3209139,28 25.1,28 L22.9,28 C22.6790861,28 22.5,27.8209139 22.5,27.6 L22.5,14.4 C22.5,14.1790861 22.6790861,14 22.9,14 L25.1,14 Z",
    id: "ExclamationCircleOutline-\u5F62\u72B6\u7ED3\u5408",
    fill: "currentColor"
  }))));
}

export default ExclamationCircleOutline;